import { render, staticRenderFns } from "./quality.vue?vue&type=template&id=3afb4ba2&scoped=true"
import script from "./quality.vue?vue&type=script&lang=js"
export * from "./quality.vue?vue&type=script&lang=js"
import style0 from "./quality.vue?vue&type=style&index=0&id=3afb4ba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb4ba2",
  null
  
)

export default component.exports